import { IModalZindex, ModalZindexTypes } from '../types';
import { SET_MODAL_ZINDEX } from '../constants/actionTypes';

export const setModalZindex = (ModalZindex: IModalZindex): ModalZindexTypes => ({
  type: SET_MODAL_ZINDEX,
  payload: ModalZindex,
});
